<ng-container *ngFor="let category of filteredCategories">
  <div class="action-group">
    <div class="action-group-category">
      <div class="action-group-name">{{ category.label | translate }}</div>
      <mat-icon
        *ngIf="!!category.description"
        [glxyTooltip]="category.description | translate"
        [tooltipTitle]="category.label | translate"
        class="action-group-description"
      >
        info_outline
      </mat-icon>
    </div>
    <div class="action-group-items">
      <ng-container *ngFor="let action of category.contents">
        <!-- If the item is disabled, only show it if the user wants to see it. -->
        <ng-container *ngIf="(action.metadata.valid && action.metadata.hasAccessToRun) || showDisabledItems">
          <div
            [matTooltip]="
              (!action.metadata.hasAccessToRun
                ? 'AUTOMATIONS.EDITOR.NO_ACCESS_TO_RUN'
                : useTriggerInvalidMessageInsteadOfActionInvalidMessage
                  ? 'AUTOMATIONS.EDITOR.WRONG_AUTOMATION_TYPE_TRIGGER'
                  : action?.taskDefinition?.marketReliant
                    ? 'AUTOMATIONS.EDITOR.MARKET_RELIANT'
                    : 'AUTOMATIONS.EDITOR.MORE_INFO_NEEDED'
              ) | translate
            "
            [matTooltipDisabled]="action.metadata.valid && action.metadata.hasAccessToRun"
          >
            <button
              class="action-button"
              (click)="taskWasClicked(action.taskDefinition)"
              [ngStyle]="{
                'border-color':
                  action.metadata.valid && action.metadata.hasAccessToRun
                    ? action.uiDefinition.iconColor
                    : DISABLED_ICON_COLOR
              }"
              [ngClass]="{
                locked: !(action.metadata.valid && action.metadata.hasAccessToRun)
              }"
              [disabled]="!(action.metadata.valid && action.metadata.hasAccessToRun)"
              data-action-group="selected-trigger-or-action"
              attr.data-action-task-type="{{ action.taskDefinition.taskType }}"
              attr.data-action="selected-{{ action.taskDefinition.id }}"
            >
              <div class="action-item">
                <div
                  class="action-icon"
                  [ngStyle]="{
                    background:
                      action.metadata.valid && action.metadata.hasAccessToRun
                        ? action.uiDefinition.iconColor
                        : DISABLED_ICON_COLOR
                  }"
                >
                  <ng-container *ngIf="isCustomIcon(action.uiDefinition.icon); else defaultIconTemplate">
                    <mat-icon [svgIcon]="action.uiDefinition.icon"></mat-icon>
                  </ng-container>
                  <ng-template #defaultIconTemplate>
                    <mat-icon>{{ action.uiDefinition.icon }}</mat-icon>
                  </ng-template>
                </div>
                <div class="action-label">
                  <div class="action-name">
                    {{ action.uiDefinition.name | translate: action.uiDefinition.nameTranslationParams }}
                  </div>
                  <div>
                    <div class="action-draft-text" *ngIf="action.taskDefinition.internal">
                      <span>{{ 'AUTOMATIONS.COMMON.INTERNAL' | translate }}</span>
                      <span *ngIf="action.taskDefinition.publishedState === DRAFT && action.taskDefinition.internal"
                        >,
                      </span>
                    </div>
                    <ng-container *ngIf="action.taskDefinition.publishedState === DRAFT; else checkForEarlyAccess">
                      <div class="action-draft-text">
                        {{ 'AUTOMATIONS.COMMON.DRAFT' | translate }}
                      </div>
                    </ng-container>
                    <ng-template #checkForEarlyAccess>
                      <ng-container *ngIf="action.taskDefinition.id === earlyAccessTaskDefinitionId">
                        <div class="action-draft-text">
                          {{ 'AUTOMATIONS.COMMON.EARLY_ACCESS' | translate }}
                        </div>
                      </ng-container>
                    </ng-template>
                  </div>

                  <div
                    class="lock-icon"
                    *ngIf="
                      !(action.metadata.valid && action.metadata.hasAccessToRun) ||
                      (hasAccessToFeatures(action.taskDefinition.requiredSubscriptionFeatures) | async) === false
                    "
                  >
                    <mat-icon>lock</mat-icon>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
